import React, { useState, Fragment } from 'react';
import {
  Card,
  CardBody,
  Button,
  Row,
  CustomInput,
  Modal,
  Input,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from 'reactstrap';
import { Colxx } from '../../../../../../components/common/CustomBootstrap';

export default function SpaceSettings({
  integration,
  saveIntegration,
}) {
  const bookingSettings = integration?.bookingConfirmationSettings || {};

  const [bookingConfirmation, setBookingConfirmation] = useState(
    bookingSettings.bookingConfirmation || 'ManualReview'
  );
  const [emailConfirmation, setEmailConfirmation] = useState(
    bookingSettings.emailConfirmation || 'Automated'
  );
  const [isAddons, setIsaddons] = useState(
    bookingSettings.addonsEnabled || false
  );
  const [showModal, setShowModal] = useState(false);
  const [contactsList, setContactsList] = useState(
    bookingSettings.contacts?.length
      ? bookingSettings.contacts
      : [
        {
          name: '',
          email: '',
          phoneNumber: '',
          isBCC: false,
        },
      ]
  );

  const AddContacts = () => {
    setContactsList((prev) => [
      ...prev,
      { name: '', email: '', phoneNumber: '', isBCC: false },
    ]);
  };

  const RemoveContacts = (index) => {
    setContactsList((prev) => prev.filter((_, i) => i !== index));
  };

  const handleChange = (value, index, type) => {
    setContactsList((prev) => {
      const updated = [...prev];
      if (type === 'Name') updated[index].name = value;
      if (type === 'Email') updated[index].email = value;
      if (type === 'Number') updated[index].phoneNumber = value;
      if (type === 'BCC') updated[index].isBCC = value;
      return updated;
    });
  };

  const handleSave = () => {
    const updatedSettings = {
      bookingConfirmation,
      emailConfirmation,
      contacts: contactsList,
      addonsEnabled: isAddons,
    };
    integration.bookingConfirmationSettings = updatedSettings;
    saveIntegration({ pageSettings: integration });
    setShowModal(false);
  };

  return (
    <Card className="mb-4">
      <Fragment>
        <CardBody>
          <div className="text-center">
            {/* Booking Confirmation */}
            <div className="mb-3">
              <h6>Booking Confirmation</h6>
              <div className="mb-2">
                <CustomInput
                  id="booking1"
                  type="radio"
                  label="Automated"
                  checked={bookingConfirmation === 'Automated'}
                  onChange={() => setBookingConfirmation('Automated')}
                />
                <CustomInput
                  id="booking2"
                  type="radio"
                  label="Manual Review"
                  checked={bookingConfirmation === 'ManualReview'}
                  onChange={() => setBookingConfirmation('ManualReview')}
                />
              </div>
            </div>

            {/* Email Confirmation */}
            <div>
              <h6>Email Confirmation</h6>
              <div className="mb-2">
                <CustomInput
                  id="email1"
                  type="radio"
                  label="Automated"
                  checked={emailConfirmation === 'Automated'}
                  onChange={() => setEmailConfirmation('Automated')}
                />
                <CustomInput
                  id="email2"
                  type="radio"
                  label="Sent Externally"
                  checked={emailConfirmation === 'SentExternally'}
                  onChange={() => setEmailConfirmation('SentExternally')}
                />
              </div>
            </div>

            {/* Notifications */}
            <div className="mb-3">
              <Button
                size="xs"
                color="success"
                outline
                style={{ marginTop: '20px', display: 'inline-block' }}
                onClick={() => setShowModal(true)}
              >
                + Add Notifications
              </Button>
            </div>

            {/* Add-On's */}
            <div>
              <h6>Add-On's</h6>
              <div className="mb-2">
                <CustomInput
                  id="addons"
                  type="checkbox"
                  label="Enabled"
                  checked={isAddons}
                  onChange={(e) => setIsaddons(e.target.checked)}
                />
              </div>
            </div>

            {/* Save */}
            <Button
              size="xs"
              color="primary"

              style={{ marginTop: '20px', display: 'inline-block' }}
              onClick={handleSave}
            >
              Save
            </Button>
          </div>
        </CardBody>

        {/* Modal */}
        <Modal isOpen={showModal} toggle={() => setShowModal(!showModal)} size="lg">
          <ModalHeader toggle={() => setShowModal(!showModal)}>
            Contacts
          </ModalHeader>
          <ModalBody>
            {contactsList.map((m, index) => (
              <Row key={index}>
                <Colxx md={3}>
                  <Input
                    className="mt-2"
                    style={{ borderRadius: '10px' }}
                    type="text"
                    value={m.name}
                    placeholder="Name"
                    onChange={(e) => handleChange(e.target.value, index, 'Name')}
                  />
                </Colxx>
                <Colxx md={3}>
                  <Input
                    className="mt-2"
                    style={{ borderRadius: '10px' }}
                    type="text"
                    value={m.email}
                    placeholder="E-mail"
                    onChange={(e) =>
                      handleChange(e.target.value, index, 'Email')
                    }
                  />
                </Colxx>
                <Colxx md={3}>
                  <Input
                    className="mt-2"
                    style={{ borderRadius: '10px' }}
                    type="text"
                    value={m.phoneNumber}
                    placeholder="Phone Number"
                    onChange={(e) =>
                      handleChange(e.target.value, index, 'Number')
                    }
                  />
                </Colxx>
                <Colxx md={1}>
                  <CustomInput
                    id={`bcc-${index}`}
                    type="checkbox"
                    className="mt-2"
                    label="BCC"
                    checked={m.isBCC}
                    onChange={(e) =>
                      handleChange(e.target.checked, index, 'BCC')
                    }
                  />
                </Colxx>
                <Colxx md={2}>
                  <Button
                    color="danger"
                    className="mt-2"
                    size="xs"
                    outline
                    onClick={() => RemoveContacts(index)}
                  >
                    Remove
                  </Button>
                </Colxx>
              </Row>
            ))}

            <Row className="my-2">
              <Colxx md={12}>
                <Button color="primary" size="xs" outline onClick={AddContacts}>
                  Add Row
                </Button>
              </Colxx>
            </Row>
          </ModalBody>

          <ModalFooter>
            <Button color="primary" onClick={() => setShowModal(false)}>
              Close
            </Button>
          </ModalFooter>
        </Modal>
      </Fragment>
    </Card>
  );
}
